// import utils
import { makeObservable, observable, action } from "mobx";
class TemplateStore {
    online = true;
    visible = true;
    focussed = true;
    drawerHeight = 0;
    constructor() {
        makeObservable(this, {
            online: observable,
            setOnline: action,
            visible: observable,
            setVisible: action,
            focussed: observable,
            setFocus: action,
            drawerHeight: observable,
            setDrawerHeight: action,
        });
    }
    setOnline(online) {
        if (this.online !== online) {
            this.online = online;
        }
    }
    setVisible(visible) {
        if (this.visible !== visible) {
            this.visible = visible;
        }
    }
    setFocus(focussed) {
        if (this.focussed !== focussed) {
            this.focussed = focussed;
        }
    }
    setDrawerHeight(drawerHeight) {
        if (this.drawerHeight !== drawerHeight) {
            this.drawerHeight = drawerHeight;
        }
    }
}
export const templateStore = new TemplateStore();
export default templateStore;
